import React, { useEffect, useState, useRef } from 'react';
import NavigationLink from './NavigationLink/NavigationLink';
import Button from '../../UI/Button/Button';
import ProfilePic from '../../ProfilePic/ProfilePic';
import Tooltip from '../../UI/Tooltip/Tooltip';
import NotificationList from '../../NotificationList/NotificationList';
import MenuItems from '../../MenuItems/MenuItems';
import NotificationIcon from '../../NotificationIcon/NotificationIcon';

import classes from './NavigationLinks.module.css';

import ShowMiniLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';
import { GetFromLocalStorage, IsStringEmpty } from '../../../utilities/CommonMethods';
import Constants from '../../../utilities/Constants';
import RouteEndPoints from '../../../utilities/RouteEndPoints';

const NavigationItems = (props) => {
    const [showCommunity, setShowCommunity] = useState(false);
    let styleClasses = [classes.NavigationLinks];
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (props.community === true) {
                setShowCommunity(true);
            } else {
                setShowCommunity(false);
            }
        }
    })

    let loginButtonStyles = '';

    if (props.topbarTheme === 'Dark') {
        styleClasses.push(classes.Dark);
        styleClasses.push(classes.AlignRight);
    } else {
        styleClasses.push(classes.Light);
        loginButtonStyles += 'TextOnlyButtonDark ';
    }

    const rightEndMenuItems = !props.userLoggedIn ?
        (
            <>
                <li className={[classes.LoginButton, classes.NonMobileOnly].join(' ')}>
                    <Button
                        label='LOGIN'
                        buttonId="login-navbar"
                        fontSize="0.85em"
                        clicked={props.loginButtonClick}
                        styleclass={loginButtonStyles + props.styleclass}
                        margin="0px 8px 0px 0px"
                        padding="8px 16px"
                    />
                </li>
            </>
        ) : (
            <>
                <li className={classes.NotificationIconContainer}>
                    <Tooltip
                        show={props.notificationsDropDownOpen}
                        content={
                            props.showLoader
                                ? <div className={classes.MiniLoaderContainer}>
                                    <ShowMiniLoader isLoading={props.showLoader} transparentBg={true} />
                                </div>
                                : <NotificationList
                                    notifications={props.notifications}
                                    onItemClick={props.onNotificationIconClick}
                                    onViewAllClick={props.onViewAllNotificationsClick}
                                    showMilestonePopup={props.showMilestonePopup}
                                    openProfileUpdatePopup={props.openProfileUpdatePopup}
                                />
                        }
                        styleclass='NotificationDropdown'
                        clicked={props.onNotificationIconClick}>
                        <div className={classes.NotificationIcon}>
                            <NotificationIcon
                                topbarTheme={props.topbarTheme}
                                countChanged={props.countChanged}
                                onNotificationIconClick={props.onNotificationIconClick}
                                unreadNotifCount={props.unreadNotifCount}
                            />
                        </div>
                    </Tooltip>
                </li>
                <li><p className={classes.Username}>{!IsStringEmpty(props.fullName) ? props.fullName : props.username}</p></li>
                <li>
                    <Tooltip
                        show={props.profileDropDownOpen}
                        content={
                            <MenuItems styleclass='ProfileDropdown'
                                logoutClicked={props.logoutClicked}
                                clicked={props.onProfileAvatarClick}
                                programType={props.programType}
                                showMDStudentPopup={props.showMDStudentPopup} />
                        }
                        clicked={props.onProfileAvatarClick}
                        styleclass="ProfileDropdown"
                        transparentBackdrop={false}>
                        <div className={classes.ProfileSection} onClick={props.onProfileAvatarClick}>
                            <ProfilePic styleclass='TopbarProfile' userProfilePic={props.userProfilePic} />
                        </div>
                    </Tooltip>
                </li>
            </>
        );

    const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;

    const jobsIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 4a2 2 0 0 0-2 2v1H4a2 2 0 0 0-2 2v3h20V9a2 2 0 0 0-2-2h-3V6a2 2 0 0 0-2-2H9zm0 2h6v1H9V6zM2 13.5V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4.5h-8V15a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1.5H2z" />
        </svg>
    );

    return (
        <>
            {
                props.showQuizNavbar
                    ? <div className={classes.QuizNavbar} >
                        <p className={classes.ProgramId}>{props.activeProgramBatchCode}</p>
                        <p className={classes.UserName}>{props.fullName}</p>
                    </div>
                    : <div className={styleClasses.join(' ')} >
                        {
                            props.userLoggedIn
                                ? <ul className={[classes.NonMobileOnly, classes.NavigationLink].join(' ')}>
                                    {
                                        isLearner ?
                                            <>
                                                {
                                                    props.programType !== "edyoda"
                                                        ? null
                                                        : <></>
                                                }
                                                <li>
                                                    <NavigationLink label='Categories' link={RouteEndPoints.CATEGORIES_PAGE} showDropdown={false} topbarTheme={props.topbarTheme} />
                                                </li>
                                                <li>
                                                    <NavigationLink label='Certificates' link={RouteEndPoints.CERTIFICATION_PAGE} showDropdown={false} topbarTheme={props.topbarTheme} />
                                                </li>
                                                <li>
                                                    <NavigationLink label='JobPrograms' link={RouteEndPoints.JOB_PROGRAMS_PAGE} showDropdown={false} topbarTheme={props.topbarTheme} />
                                                </li>
                                                <li>
                                                    <NavigationLink isExternal={true} icon={jobsIcon} label='Jobs' link={"https://www.edyoda.com/jobs"} showDropdown={false} topbarTheme={props.topbarTheme} showNewLabel={false} />
                                                </li>
                                                <li>
                                                    <NavigationLink isExternal={true} label={`FAQ`} link={"https://www.edyoda.com/faq"} showDropdown={false} topbarTheme={props.topbarTheme} showNewLabel={false} />
                                                </li>
                                                <li>
                                                    <NavigationLink label='Contact Support' link={RouteEndPoints.CONTACT_US_PAGE} showDropdown={false} topbarTheme={props.topbarTheme} />
                                                </li>
                                            </>
                                            :
                                            <>
                                                <li>
                                                    <NavigationLink label='Categories' link={RouteEndPoints.CATEGORIES_PAGE} showDropdown={false} topbarTheme={props.topbarTheme} />
                                                </li>
                                                <li>
                                                    <NavigationLink label='Certificates' link={RouteEndPoints.CERTIFICATION_PAGE} showDropdown={false} topbarTheme={props.topbarTheme} />
                                                </li>
                                                <li>
                                                    <NavigationLink label='Job Programs' link={RouteEndPoints.JOB_PROGRAMS_PAGE} showDropdown={false} topbarTheme={props.topbarTheme} />
                                                </li>
                                                <li>
                                                    <NavigationLink isExternal={true} icon={jobsIcon} label='Jobs' link={"https://www.edyoda.com/jobs"} showDropdown={false} topbarTheme={props.topbarTheme} showNewLabel={false} />
                                                </li>
                                            </>
                                    }
                                </ul>
                                : null
                        }

                        <ul className={classes.RightEndMenus}>
                            {
                                props.topbarTheme === 'Light' && !props.userLoggedIn
                                    ? null
                                    : rightEndMenuItems
                            }
                        </ul>
                    </div>
            }
        </>
    );
}

export default NavigationItems;
